// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L6 6L11 1%27 stroke=%27%23BDBDBD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sales Contact Page Styles */
.scl--web-page-sales-contact{
    min-height: 100vh;
    width: 100%;
    background: #000000;
}
.scl--web-page-sales-contact-container {
  display: flex;
  flex-direction: column;
  padding: 100px var(--global-desktop-padding-left) 20px var(--global-desktop-padding-left);
  max-width: var(--global-desktop-width-resp);
  margin: 0 auto;

}

/* Breadcrumb */
.scl--web-page-sales-contact-breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  height: 16px;
}

.scl--web-page-sales-contact-breadcrumb-text {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #7D8187;
  cursor: pointer;
  text-decoration: none;
  transition: text-decoration 0.2s ease;
}

.scl--web-page-sales-contact-breadcrumb-text:hover {
  text-decoration: underline;
}

.scl--web-page-sales-contact-breadcrumb-separator {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #7D8187;
}

.scl--web-page-sales-contact-breadcrumb-current {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
}

.scl--web-page-sales-contact-contact-section {
  padding: 10px 0px 40px 0px;
}

.scl--web-page-sales-contact-header {
  margin-bottom: 40px;
}

.scl--web-page-sales-contact-title {
   font-family: var(--primary-font);
  font-style: normal;
  font-weight: 500;
  font-size: 70px;
  line-height: 120%;
  background: linear-gradient(360deg, #A2A2A2 -108.76%, #ADADAD 10.54%, #DDDDDD 89.05%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 10px 0;
}

.scl--web-page-sales-contact-subtitle {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 20px;
  line-height: 150%;
  color: #7D8187;
  margin: 0;
}

.scl--web-page-sales-contact-content {
  display: flex;
  flex-direction: row;
  gap: 40px;
  width: 100%;
}

.scl--web-page-sales-contact-left-section {
  flex: 0 0 350px;
  width: 350px;
}

.scl--web-page-sales-contact-right-section {
  flex: 1;
  max-width: 855px;
}

.scl--web-page-sales-contact-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.scl--web-page-sales-contact-form-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.scl--web-page-sales-contact-input,
.scl--web-page-sales-contact-select,
.scl--web-page-sales-contact-textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #424242;
  outline: none;
  transition: border-color 0.3s ease;
}

.scl--web-page-sales-contact-input::placeholder,
.scl--web-page-sales-contact-select::placeholder,
.scl--web-page-sales-contact-textarea::placeholder {
  color: #BDBDBD;
}

.scl--web-page-sales-contact-input:focus,
.scl--web-page-sales-contact-select:focus,
.scl--web-page-sales-contact-textarea:focus {
  border-color: #757575;
}

.scl--web-page-sales-contact-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 20px center;
  padding-right: 50px;
  color: #BDBDBD;
}

.scl--web-page-sales-contact-select:focus,
.scl--web-page-sales-contact-select:valid {
  color: #424242;
}

.scl--web-page-sales-contact-form-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.scl--web-page-sales-contact-country-group {
  flex: 0 0 143px;
}

.scl--web-page-sales-contact-phone-group {
  flex: 1;
}

.scl--web-page-sales-contact-country-select {
  width: 100%;
}

.scl--web-page-sales-contact-textarea {
  resize: vertical;
  min-height: 150px;
}

.scl--web-page-sales-contact-consent-group {
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: flex-start;
  margin-top: 10px;
}

.scl--web-page-sales-contact-checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 2px;
}

.scl--web-page-sales-contact-consent-label {
  font-family: var(--primary-font);
  font-style: Light;
  font-weight: 274;
  font-size: 18px;
  line-height: 30px;
  color: #7D8187;
  cursor: pointer;
  user-select: none;
  letter-spacing: 0%;
}

.scl--web-page-sales-contact-consent-label .scl--web-page-sales-contact-consent-label-bold {
  color: #FFFFFF;
}

/* Actions Row - Attach and Submit buttons */
.scl--web-page-sales-contact-actions-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 10px;
  
}

/* File Upload Group */
.scl--web-page-sales-contact-file-upload-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.scl--web-page-sales-contact-attach-button {
  width: 139px;
  height: 40px;
  flex-shrink: 0;
}

.scl--web-page-sales-contact-file-info {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 14px;
  line-height: 150%;
  color: #7D8187;
}

.scl--web-page-sales-contact-required-asterisk {
  color: #EB5252;
}

.scl--web-page-sales-contact-file-name {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #FFFFFF;
}

/* Submit Button */
.scl--web-page-sales-contact-submit-button {
  width: 139px;
  height: 40px;
  flex-shrink: 0;
}

/* Footer Styles */
.scl--web-page-sales-contact-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--web-page-sales-contact-footer-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.scl--web-page-sales-contact-footer-copyright {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #7D8187;
}
/* First item's button has background */
.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button {
  background: #282828;
}

/* Last item's button is transparent */
.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button {
  background: transparent;
}

.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button:hover{
   background: #FFFFFF1A;
}

`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/sales-contact/css/salesContact.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yFAAyF;EACzF,2CAA2C;EAC3C,cAAc;;AAEhB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;GACG,gCAAgC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qFAAqF;EACrF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kCAAkC;AACpC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yDAAuQ;EACvQ,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;;AAElB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;;AAEA;GACG,qBAAqB;AACxB","sourcesContent":["/* Sales Contact Page Styles */\n.scl--web-page-sales-contact{\n    min-height: 100vh;\n    width: 100%;\n    background: #000000;\n}\n.scl--web-page-sales-contact-container {\n  display: flex;\n  flex-direction: column;\n  padding: 100px var(--global-desktop-padding-left) 20px var(--global-desktop-padding-left);\n  max-width: var(--global-desktop-width-resp);\n  margin: 0 auto;\n\n}\n\n/* Breadcrumb */\n.scl--web-page-sales-contact-breadcrumb {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 10px;\n  height: 16px;\n}\n\n.scl--web-page-sales-contact-breadcrumb-text {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  color: #7D8187;\n  cursor: pointer;\n  text-decoration: none;\n  transition: text-decoration 0.2s ease;\n}\n\n.scl--web-page-sales-contact-breadcrumb-text:hover {\n  text-decoration: underline;\n}\n\n.scl--web-page-sales-contact-breadcrumb-separator {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  color: #7D8187;\n}\n\n.scl--web-page-sales-contact-breadcrumb-current {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  color: #FFFFFF;\n}\n\n.scl--web-page-sales-contact-contact-section {\n  padding: 10px 0px 40px 0px;\n}\n\n.scl--web-page-sales-contact-header {\n  margin-bottom: 40px;\n}\n\n.scl--web-page-sales-contact-title {\n   font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 70px;\n  line-height: 120%;\n  background: linear-gradient(360deg, #A2A2A2 -108.76%, #ADADAD 10.54%, #DDDDDD 89.05%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0 0 10px 0;\n}\n\n.scl--web-page-sales-contact-subtitle {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 20px;\n  line-height: 150%;\n  color: #7D8187;\n  margin: 0;\n}\n\n.scl--web-page-sales-contact-content {\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n  width: 100%;\n}\n\n.scl--web-page-sales-contact-left-section {\n  flex: 0 0 350px;\n  width: 350px;\n}\n\n.scl--web-page-sales-contact-right-section {\n  flex: 1;\n  max-width: 855px;\n}\n\n.scl--web-page-sales-contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.scl--web-page-sales-contact-form-group {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.scl--web-page-sales-contact-input,\n.scl--web-page-sales-contact-select,\n.scl--web-page-sales-contact-textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 16px 20px;\n  background: #FFFFFF;\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  color: #424242;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.scl--web-page-sales-contact-input::placeholder,\n.scl--web-page-sales-contact-select::placeholder,\n.scl--web-page-sales-contact-textarea::placeholder {\n  color: #BDBDBD;\n}\n\n.scl--web-page-sales-contact-input:focus,\n.scl--web-page-sales-contact-select:focus,\n.scl--web-page-sales-contact-textarea:focus {\n  border-color: #757575;\n}\n\n.scl--web-page-sales-contact-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%23BDBDBD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 20px center;\n  padding-right: 50px;\n  color: #BDBDBD;\n}\n\n.scl--web-page-sales-contact-select:focus,\n.scl--web-page-sales-contact-select:valid {\n  color: #424242;\n}\n\n.scl--web-page-sales-contact-form-row {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.scl--web-page-sales-contact-country-group {\n  flex: 0 0 143px;\n}\n\n.scl--web-page-sales-contact-phone-group {\n  flex: 1;\n}\n\n.scl--web-page-sales-contact-country-select {\n  width: 100%;\n}\n\n.scl--web-page-sales-contact-textarea {\n  resize: vertical;\n  min-height: 150px;\n}\n\n.scl--web-page-sales-contact-consent-group {\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n  align-items: flex-start;\n  margin-top: 10px;\n}\n\n.scl--web-page-sales-contact-checkbox {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 2px;\n}\n\n.scl--web-page-sales-contact-consent-label {\n  font-family: var(--primary-font);\n  font-style: Light;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 30px;\n  color: #7D8187;\n  cursor: pointer;\n  user-select: none;\n  letter-spacing: 0%;\n}\n\n.scl--web-page-sales-contact-consent-label .scl--web-page-sales-contact-consent-label-bold {\n  color: #FFFFFF;\n}\n\n/* Actions Row - Attach and Submit buttons */\n.scl--web-page-sales-contact-actions-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 10px;\n  \n}\n\n/* File Upload Group */\n.scl--web-page-sales-contact-file-upload-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n}\n\n.scl--web-page-sales-contact-attach-button {\n  width: 139px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.scl--web-page-sales-contact-file-info {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 14px;\n  line-height: 150%;\n  color: #7D8187;\n}\n\n.scl--web-page-sales-contact-required-asterisk {\n  color: #EB5252;\n}\n\n.scl--web-page-sales-contact-file-name {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #FFFFFF;\n}\n\n/* Submit Button */\n.scl--web-page-sales-contact-submit-button {\n  width: 139px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n/* Footer Styles */\n.scl--web-page-sales-contact-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 0;\n  margin-top: auto;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--web-page-sales-contact-footer-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n}\n\n.scl--web-page-sales-contact-footer-copyright {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #7D8187;\n}\n/* First item's button has background */\n.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button {\n  background: #282828;\n}\n\n/* Last item's button is transparent */\n.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button {\n  background: transparent;\n}\n\n.scl--web-page-sales-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button:hover{\n   background: #FFFFFF1A;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
